import React, { useRef } from 'react'
import { useState } from "react"

import Paper from '@material-ui/core/Paper'
import { Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'

import Subtitle from '@base/Subtitle'
import Toast from '@base/Toast'
import TextField from "@base/Inputs/Text"

import escolaService from "@services/EscolaService"

import { mecCodeMask, deMask } from '@helpers/MaskHelper'

const __MECCODE_LENGTH = 8;
const __DE_LENGTH = 12;
const __WAITING_TIME_TYPING = 300;

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color : "#333",
				fontSize: 24,
			}
		}
	)
);

export const BuscaEscola = (props) => {
	const [inepOuDe, setInepOuDe] = useState("");

	const [timerTyping, setTimerTyping] = useState(0);

	const aoEncontrar =  props.aoencontrar  ? props.aoencontrar : () => {};
	const aoNaoEncontrar = props.aonaoencontrar ? props.aonaoencontrar : () => {};

	const toastRef = useRef(null);
	const classes = useStyles();
	 console.log("PROCESSO " + props.processo);

	const carregaInformacoesDaEscola = (inepOuDe) => {

		let isDe = /35[A-Za-z]{2}/.test(inepOuDe.target.value.substring(0,4));
		if ((!isDe) && (inepOuDe.target.value.length === __MECCODE_LENGTH)) {
			// console.log("Usei INEP para consulta");
			setInepOuDe(mecCodeMask(inepOuDe.target.value));
		} else if ((isDe) && (inepOuDe.target.value.length === __DE_LENGTH)) {
			// console.log("Usei DE para consulta");
			setInepOuDe(deMask(inepOuDe.target.value));
		} else {
			// console.log("Usei nenhuma mascara para consulta");
			setInepOuDe(inepOuDe.target.value);
		}

		clearTimeout(timerTyping);

	    setTimerTyping(setTimeout(() => {
			if (((inepOuDe.target.value.length === __MECCODE_LENGTH && !isDe) ||
					(inepOuDe.target.value.length === __DE_LENGTH && isDe))) {
				let inep = inepOuDe.target.value;

				if(inepOuDe.target.value.length === __DE_LENGTH)  inep = inepOuDe.target.value.substr(4);

				escolaService.listarPorCodigoInepOuEticket(props.processo.id ? props.processo.id : props.processo, inep).then(resposta => {
					if (resposta.status === 200) {
						aoEncontrar(resposta.data);

						if (!props.manterinep)
							setInepOuDe("");
					} else {
						aoNaoEncontrar();
						toastRef.current.show("error", "Escola Não Encontrada.");

						if (!props.manterinep)
							setInepOuDe("");
					}
				}).catch(() => toastRef.current.show("error", "Ocorreu um Problema ao Buscar a Escola."));
			}
		}, __WAITING_TIME_TYPING));
	}

	const textField =
		<Grid alignItems="center" container>
			<Grid item sm={props.size ?? 12}>
				<TextField
					ref={props.inputRef}
					{...props}
					label={props.label ? props.label : (props.permiteeticket ? "Código INEP ou DE" : "Código INEP")}
					value={props.permiteeticket ? deMask(inepOuDe) : mecCodeMask(inepOuDe)}
					onChange={carregaInformacoesDaEscola}
					inputProps={{ maxLength: (props.permiteeticket ? __DE_LENGTH : __MECCODE_LENGTH) }}
				/>
			</Grid>
		</Grid>

    return (
		<>
			<Toast ref={toastRef} />
			{ !props.ocultarsubtitulo ?
				<Paper className={classes.wrapper} elevation={0} spacing={2}>
					<Subtitle>
						{props.label ? props.label : `Informe o Código INEP ${props.permiteeticket ? `ou DE` : ""}`}
					</Subtitle>
					{textField}
				</Paper>
			:
				textField
			}
	   	</>
    );
}

export default BuscaEscola;
